import React from "react";
import { Layer, Source } from "react-map-gl";
import { useSelector } from "react-redux";

const LineOfRoute = () => {
  const { route } = useSelector((state) => state.routeReducer);
  const routeLine = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: route?.coordinates || [],
    },
  };

  if (route?.coordinates && route?.coordinates.length >= 2)
    return (
      <Source id="route" type="geojson" data={routeLine}>
        <Layer
          id="route"
          type="line"
          source="route"
          layout={{
            "line-join": "round",
            "line-cap": "round",
          }}
          paint={{
            "line-color": "black",
            "line-width": 10,
            "line-opacity": 0.8,
          }}
        />
      </Source>
    );
};

export default LineOfRoute;
